<p-dialog 
  [visible]="true" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  styleClass="!rounded-[2rem] overflow-hidden shadow-2xl"
  (onHide)="close.emit()"
>
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full pr-8">
      <h3 class="text-xl font-bold text-slate-800">
        {{ 'confirm_delete' | translate }}
      </h3>
    </div>
  </ng-template>
  <div class="p-8 w-full max-w-sm flex flex-col gap-6 animate-fadeIn">
    <div class="flex flex-col items-center gap-6 text-center">
      <div class="w-20 h-20 rounded-[2.5rem] bg-rose-50 flex items-center justify-center text-rose-500">
        <i class="pi pi-trash text-4xl"></i>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-sm font-medium text-slate-500">
          {{ 'confirm_delete_text' | translate }} 
          <span class="font-bold text-slate-700">"{{ item.procedure_name || item.description }}"</span>?
        </p>
      </div>
    </div>
    <div class="flex gap-4 pt-4">
      <app-button
        [label]="'common_no' | translate"
        variant="secondary"
        (onClick)="close.emit()"
        class="flex-1"
      ></app-button>
      <app-button
        [label]="'common_yes_delete' | translate"
        [variant]="'danger'"
        [loading]="saving"
        (onClick)="delete()"
        class="flex-1"
      ></app-button>
    </div>
  </div>
</p-dialog>
